import { Component, computed, input, signal } from '@angular/core';

@Component({
  selector: 'rid-compressable-klank-card',
  imports: [],
  templateUrl: './rid-compressable-klank-card.html',
})
export class RidCompressableKlankCard {
  content = input.required<string>();
  appearance = input<'DEFAULT' | 'ALMOST'>('DEFAULT');

  compressed = signal<{ index: number; length: number } | undefined>(undefined);

  tw = computed(() => {
    const compressed = this.compressed();
    if (compressed) {
      const { index, length } = compressed;

      return `border-y-3 ${index === 0 ? 'ml-1 pl-4 border-l-3 rounded-bl-md rounded-tl-md' : ''} ${index === length - 1 ? 'mr-1 pr-4 border-r-3 rounded-br-md rounded-tr-md' : ''}`;
    }

    return `mx-1 border-3 p-4 rounded-md`;
  });

  appearanceTw = computed(() =>
    this.appearance() === 'ALMOST'
      ? 'border-surface-300 bg-white text-orange-600 underline decoration-2 underline-offset-4'
      : 'border-surface-300 bg-white',
  );
}
